<template>
  <div class="tag-panel">
      <span class="tag tag-left custom new-construction-tag" v-if="isNewConstruction"><span>New Construction</span></span>
      <span class="tag tag-left custom ready-to-build-tag" v-else-if="isReadyToBuild"><span>Ready To Build</span></span>
      <span class="tag tag-left custom pending-backup-offer-tag" v-else-if="property.showPendingBackupOffer"><span>{{ property.listingStatusDisplayName }}</span></span>
      <span class="tag tag-left custom new-tag" v-else-if="isNewTag">
        <span>{{ molang('search.card.newAgo') }}</span>
        <span data-allow-mismatch="text">{{ property.createTimeDisplay.replace('Minutes', 'Min') }}</span>
      </span>
      <span class="tag tag-left custom sold-tag" v-else-if="isSoldTag">
        <span>{{ property.houseRealStatusDisplay }}</span>
        <span data-allow-mismatch="text" v-if="property.showSoldDate">{{ $filters.formatDate(property.soldDate, { year: '2-digit' }) }}</span>
      </span>
      <span class="tag tag-left custom open-tag" v-else-if="isOpenTag">
        <span>{{ molang('search.card.open') }}</span>
        <span data-allow-mismatch="text">{{ property.openDateV1 }}</span>
      </span>
      <span class="tag tag-left custom pricecut-tag" v-else-if="isPriceCutTag">
        <span :class="property.isPriceReduced ? 'price-reduced' : 'price-increased'">
          <i :class="{
              'icon-arrow-down-circle-filled': property.isPriceReduced,
              'icon-send-ios': !property.isPriceReduced
            }"
          ></i>
          {{ $filters.formatFriendlyPrice(property.priceChange) }}
        </span>
      </span>
      <span class="tag tag-left custom listingby-movoto-tag" v-else-if="isListingByMovoto">
        <span>{{ molang('dpp.propertyNearby.listedBy') }}</span>
      </span>

      <span
          v-if="showLeadButton"
          aria-label="select Property"
          class="circle small tag-right"
          @click.stop="emitOpenDpp"
          :class="selectedCard ? 'bg-green' : 'bg-white'"
      >
        <i :class="{ 'icon-check': selectedCard }"></i>
      </span>
      <button
          v-else
          type="button"
          aria-label="Favorite Property"
          @click.stop="favoriteAction"
          class="favorite circle small bg-white tag-right"
          title="Save"
      >
        <i class="icon-heart-o" :class="{ active: isFavorite }"></i>
      </button>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { getCookie } from '../../utilities/nojq/_cookie.js';
import { setStorage, getStorage } from '../../utilities/nojq/_localstorage.js';

export default {
  name: 'PropertyCardTags',
  props: {
    property: Object,
    selectedCard: Boolean,
    showLeadButton: Boolean,
    cardFilter: String,
    theme: String,
  },
  inject: ['$eventBus'],
  methods: {
    ...mapActions('glb', ['updateFavorite']),
    favoriteAction() {
      const { propertyId, listingId, isPrOnly, formatMlsInfo, geo, mlsDescription, mlsLogoSrc, photoCount, tnImgPath } = this.property;
      const isFavorite = !this.favoriteListings.includes(propertyId);
      const options = {
        propertyData: { formatMlsInfo, geo, mlsDescription, mlsLogoSrc, photoCount, tnImgPath },
        propertyId,
        listingId,
        isPrOnly,
        isFavorite,
        trigger: this.$options.name,
        lite: true,
      };
      setStorage('pendingRequestName', 'addfavorite');
      setStorage('favoriteHome', JSON.stringify(options));

      this.updateFavorite(options).then((res) => {
        if (res?.status?.code === 0) {
          if (isFavorite) {
            this.$eventBus.$emit('dialog-center-tip', `<span class="text-bold">Success!</span> <span class="text-medium">Home saved.</span>`);
          }
          this.$emit('updateFavListing', isFavorite);

          const noLead = +getStorage('hotleadCount') === 0;
          const noPhone = !(this.glb.hotleadInfo.phone || this.glb.user.phone);
          if (isFavorite && noLead && noPhone && !this.glb.rentals) {
            this.$eventBus.$emit('eventbus-pop-schedule-lead');
          }
        }
      });
    },
    emitOpenDpp() {
        this.$emit('openDpp');
    },
  },
  computed: {
    ...mapGetters('glb', ['glb', 'favoriteListings']),
    isFavorite() {
      return this.favoriteListings.includes(this.property.propertyId);
    },
    isNewConstruction() {
      const { nhsListingType } = this.property;
      return (this.cardFilter === 'newConstruction' && nhsListingType !== 'Ready To Build') || (!this.cardFilter && nhsListingType === 'New Construction');
    },
    isReadyToBuild() {
      return (!this.cardFilter || this.cardFilter === 'newConstruction') && this.property.nhsListingType === 'Ready To Build';
    },
    isNewTag() {
      return !this.cardFilter && this.property.isNew;
    },
    isSoldTag() {
      return this.property.isSold;
    },
    isOpenTag() {
      return this.cardFilter === 'openHouse' || (!this.cardFilter && this.property.openDate);
    },
    isPriceCutTag() {
      const { showPriceChange, hideDaysOnMarket, labelName } = this.property;
      const isSavedHomesPage = this.glb.pageType === 'vmymovoto_savedhomes';
      const isAUC = labelName === 'Active Under Contract';
      const hasPriceCut = showPriceChange && !hideDaysOnMarket && !(isSavedHomesPage && isAUC);
      return this.cardFilter === 'priceCut' || (!this.cardFilter && hasPriceCut);
    },
    isListingByMovoto() {
      return this.cardFilter === 'listedByMovoto' || (!this.cardFilter && this.property.listingByMovoto);
    },
  },
};
</script>
